import * as types from '../actions';

const initialState = {
	fieldDetailsList:[],
	vehicleInfoList:[],
  vehicleInfoRetrieve:[],
	fieldDetailsSavedList:[],
	vehicleInfoSavedList:[],
	vehicleInfoStatus:'',
	vehicleInfoActivity:''

};

export default function(state = initialState, action) {
  const response = action.data;
  let timeVar = '~~'+Date.now(); 
  switch(action.type) {    

    case types.LIST_FIELD_DETAILS_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            fieldDetailsList: action.response.data.results ? action.response.data.results : action.response.data?action.response.data:[],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.LIST_FIELD_DETAILS_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          fieldDetailsList: action.response.data ? action.response.data : [],
          vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleInfoActivity:types.LIST_FIELD_DETAILS_ERROR+timeVar,  
        }
      }
    case types.SAVE_FIELD_DETAILS_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            fieldDetailsSavedList: action.response.data.results ? action.response.data.resultss : [],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.SAVE_FIELD_DETAILS_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          fieldDetailsSavedList: action.response.data ? action.response.data : [],
          vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleInfoActivity:types.SAVE_FIELD_DETAILS_ERROR+timeVar,  
        }
      }
    case types.DELETE_FIELD_DETAILS_SUCCESS:
        if(action.response.status && action.response.status===200){
          return {
              ...state, 
              fieldDetailsSavedList: action.response.data.results ? action.response.data.resultss : [],
              vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
              vehicleInfoActivity:types.DELETE_FIELD_DETAILS_SUCCESS+timeVar,  
          } 
        }
        else {
          return {
            ...state,
            fieldDetailsSavedList: action.response.data ? action.response.data : [],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.DELETE_FIELD_DETAILS_ERROR+timeVar,  
          }
        }


    case types.LIST_VEHICLE_INFO_SUCCESS:
     if(action.response.status && action.response.status===200){
        return {
            ...state, 
            vehicleInfoList: action.response.data.results ? action.response.data.results : action.response.data?action.response.data:[],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.LIST_VEHICLE_INFO_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          vehicleInfoList: action.response.data ? action.response.data : [],
          vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleInfoActivity:types.LIST_VEHICLE_INFO_ERROR+timeVar,  
        }
      }
    case types.SAVE_VEHICLE_INFO_SUCCESS:
      if(action.response.status && action.response.status===200){
        return {
            ...state, 
            vehicleInfoSavedList: action.response.data.results ? action.response.data.results : [],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.SAVE_VEHICLE_INFO_SUCCESS+timeVar,  
        } 
      }
      else {
        return {
          ...state,
          vehicleInfoSavedList: action.response.data ? action.response.data : [],
          vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
          vehicleInfoActivity:types.SAVE_VEHICLE_INFO_ERROR+timeVar,  
        }
      }
      case types.UPDATE_VEHICLE_INFO_SUCCESS:
        if(action.response.status && action.response.status===200){
          return {
              ...state, 
              vehicleInfoSavedList: action.response.data.results ? action.response.data.results : [],
              vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
              vehicleInfoActivity:types.UPDATE_VEHICLE_INFO_SUCCESS+timeVar,  
          } 
        }
        else {
          return {
            ...state,
            vehicleInfoSavedList: action.response.data ? action.response.data : [],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.UPDATE_VEHICLE_INFO_ERROR+timeVar,  
          }
      }
      case types.DELETE_VEHICLE_INFO_SUCCESS:
        if(action.response.status && action.response.status===200){
          return {
              ...state, 
              vehicleInfoSavedList: action.response.data.results ? action.response.data.results : [],
              vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
              vehicleInfoActivity:types.DELETE_VEHICLE_INFO_SUCCESS+timeVar,  
          } 
        }
        else {
          return {
            ...state,
            vehicleInfoSavedList: action.response.data ? action.response.data : [],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.DELETE_VEHICLE_INFO_ERROR+timeVar,  
          }
      }
      case types.GET_VEHICLE_INFO_SUCCESS:
        if(action.response.status && action.response.status===200){
          return {
              ...state, 
              vehicleInfoRetrieve: action.response.data ? action.response.data: [],
              vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
              vehicleInfoActivity:types.GET_VEHICLE_INFO_SUCCESS+timeVar,  
          } 
        }
        else {
          return {
            ...state,
            vehicleInfoRetrieve: action.response.data ? action.response.data : [],
            vehicleInfoStatus: action.response.data.status ? action.response.data.status : '',  
            vehicleInfoActivity:types.GET_VEHICLE_INFO_ERROR+timeVar,  
          }
      }
    case types.CLEAR:
        return {
            ...state,
            status:0,
            count:'',
            activity:types.CLEAR,
            vehicleInfoActivity:types.CLEAR,
        }

    default:
      return state;
  }
};